import { z } from 'zod';
import { ga4MetricsSchema, gscQueryRowSchema } from './googleMetrics.js';
export const AUDIENCE_INSIGHT_KINDS = ['ga4', 'gsc', 'scraper', 'website', 'campaign'];
export const AUDIENCE_INSIGHT_LABEL_KINDS = ['fact', 'hypothesis'];
export const audienceInsightRefreshSchema = z.object({
    days: z.number().int().min(7).max(90).default(30),
});
export const insightEvidenceSchema = z.object({
    type: z.literal('integration_snapshot'),
    connector_type: z.enum(['ga4', 'gsc']),
    period_start: z.string(),
    period_end: z.string(),
    snapshot_count: z.number().int().min(0),
});
export const ga4InsightPayloadSchema = z.object({
    integration_status: z.enum(['active', 'missing', 'error', 'pending']),
    metrics: ga4MetricsSchema.partial().optional(),
    snapshot_count: z.number().int().min(0),
    evidence: z.array(insightEvidenceSchema),
    trend_sessions_pct: z.number().nullable().optional(),
});
export const gscInsightPayloadSchema = z.object({
    integration_status: z.enum(['active', 'missing', 'error', 'pending']),
    metrics: z
        .object({
        clicks: z.number().int().min(0),
        impressions: z.number().int().min(0),
        ctr: z.number().min(0).max(1),
        position: z.number().min(0),
        top_queries: z.array(gscQueryRowSchema).max(10),
    })
        .optional(),
    snapshot_count: z.number().int().min(0),
    evidence: z.array(insightEvidenceSchema),
    trend_clicks_pct: z.number().nullable().optional(),
});
//# sourceMappingURL=audienceInsight.js.map